import router from '../router'
const AIRLINE_UPDATED = (state, airline) => {
  state.airline = airline

  if (airline && airline.params && airline.params.self_service_portal_css_override) {
    if (!document.getElementById('self_service_portal_css_override')) {
      const link = document.createElement('link')
      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.id = 'self_service_portal_css_override'
      document.head.appendChild(link)

      // Set this up with cachebusting since we can't control the endpoint caching
      let href = airline.params.self_service_portal_css_override.replace(/"/g, '')
      href += !href.includes('?') ? '?_sfs=' : '&_sfs='
      href += Math.random() * 1000000000

      link.href = href
    }
  }
}
const LANG_UPDATED = (state, lang) => {
  state.lang = lang
}
const PAX_INIT = (state, pax) => {
  // Fix 15677 - TypeError call(src/views/Home)
  // The logic test case set -> /home?secret=[Filtered] the unreal value of secret
  if (_.isEmpty(pax)) {
    router.push({ path: '/page-error' })
    return
  }
  pax.flow_status_enabled = pax & pax.params && pax.params.flow_status // This will always be 0
  // @FIXME: Use vue syntax
  let cookiestring = RegExp('curPaxID' + pax.group_id + '[^;]+').exec(document.cookie)
  const paxIDFromCookie = parseInt(decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./, '') : ''), 10)

  if (isFinite(paxIDFromCookie) && paxIDFromCookie > 0) {
    pax.curPaxID = paxIDFromCookie
  }

  let paxChanged = true

  try {
    paxChanged = JSON.stringify(state.pax) !== JSON.stringify(pax)
  } catch (e) {
    //
  }

  if (paxChanged) {
    state.pax = pax
  }
}
const PAX_UPDATED = (state, pax) => {
  state.pax.params = _.extend(state.pax.params, pax.params)
}
const GET_TITLE = (state, title) => {
  state.title = title
}
const GET_INTERNAL_CMT_ID = (state, internalCmtId) => {
  state.internalCmtId = internalCmtId
}
const GET_PAXS_GROUP = (state, paxsGroup) => {
  state.paxsGroup = paxsGroup
  // state.currPaxInfo = [];
}
const CONFIRM_UPDATE = (state, confirm) => {
  state.isConfirmYet = confirm
}
const UPDATE_RECEIVE_MESSAGE = (state, receiveMsg) => {
  state.pax.receive_message.receive_message = receiveMsg
}
const UPDATE_INFO_FLIGHT = (state, status) => {
  state.isInfoFlightPage = status
}

const UPDATE_GOOGLE_API_STATUS = (state, status) => {
  state.validGGApi = status
}
const TEMPLATE_INIT = (state) => {
  const lang_code = state.pax.lang_code ?? state.lang.lang_code
  state.direction = state.airline.langs?.find((lang) => lang.lang_code === lang_code)?.direction ?? 'ltr'
}

export default {
  AIRLINE_UPDATED,
  LANG_UPDATED,
  PAX_INIT,
  PAX_UPDATED,
  GET_TITLE,
  GET_INTERNAL_CMT_ID,
  GET_PAXS_GROUP,
  CONFIRM_UPDATE,
  UPDATE_RECEIVE_MESSAGE,
  UPDATE_INFO_FLIGHT,
  UPDATE_GOOGLE_API_STATUS,
  TEMPLATE_INIT
}
